<template>
  <div class="edit-lib" v-loading="loading">
    <lib-form ref="libForm" @submit="realSubmit"></lib-form>

    <div class="page-fixed">
      <div class="edit-lib__fixed">
        <Button type="primary" @click.stop="submit">确认提交</Button>
      </div>
    </div>
  </div>
</template>
<script>
import libForm from './components/libForm'
export default {
  components: { libForm },
  data() {
    return {
      servicetype: '', // 代表主数据 医院 药店 商业公司 第三终端
      id: '', // 如果是编辑需要的本条数据的id
      loading: false // 编辑状态页面加载
    }
  },
  mounted() {
    this.servicetype = this.$route.params.type
    this.id = this.$route.params.id
    if (this.$route.name === 'addLib') {
      this.$store.dispatch('setPage', {
        title: '新增',
        url: '',
        type: 'normal card-footer'
      })
    } else {
      this.$store.dispatch('setPage', {
        title: '编辑',
        url: '',
        type: 'normal card-footer'
      })
      this.loading = true
      this.getEditData() // 获取编辑的数据
    }
  },
  methods: {
    getEditData() {
      setTimeout(() => {
        this.loading = false
      }, 2000)
    },
    submit() {
      this.$refs.libForm && this.$refs.libForm.submit()
    },
    realSubmit(libForm) {
    }
  }
}
</script>
<style lang="scss" scoped="">
  .edit-lib__fixed {
    width: 1000px;
    margin: 0 auto;
  }
</style>
